export default __webpack_public_path__ + "static/media/arrow_up.cb6174f3.svg";